// import { Injectable } from '@angular/core';
// import {
//   ActivatedRouteSnapshot,
//   CanActivate,
//   Router,
//   RouterStateSnapshot,
// } from '@angular/router';
// import { DataService } from 'src/app/services/data/data.service';
// import { permissions } from '../../permissions';
// import { UtilityService } from 'src/app/services/utility/utility.service';

// @Injectable({
//   providedIn: 'root',
// })
// export class PermissionGuard implements CanActivate {
//   constructor(
//     private dataService: DataService,
//     private router: Router,
//     private utilityService: UtilityService
//   ) {}

//   tempPermission: any;
//   selectedOutlet: any;
//   // counter = 3;

//   canActivate(
//     route: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot
//   ): boolean {
//     // admin access
//     if (this.dataService.userDetails.is_admin === 1) {
//       return true;
//     } else {
//       let url = state.url;
//       let returnValue = false;
//       if (url) {
//         // handle for query params
//         if (url.includes('?')) {
//           url = url.split('?')[0];
//         }
//         let urlSegments = url.split('/');
//         // to make all reports accessible for all users who have access for reports
//         if (urlSegments.includes('reports')) {
//           url = `/${urlSegments[1]}`;
//         }
//         const queryParams = route.params;
//         //console.log(isNaN(queryParams.mode));
//         //   console.log(this.areQueryParamsWithoutNumbers(queryParams));

//         if (this.areQueryParamsWithoutNumbers(queryParams)) {
//           //to check if its contain the number then we will remove it its its not we are not gone remove it as its
//           //creating the the scenario where the feature id matching with any feature id as its making same url for every cases ex contact case its creating same url for all like vendor ,customer and staff
//           if (queryParams) {
//             Object.values(queryParams).forEach((element) => {
//               urlSegments = urlSegments.filter((ele: any) => ele !== element);
//             });
//             url = urlSegments.join('/');
//           }
//         }

//         this.selectedOutlet = this.getSelectedOutlet();
//         if (this.selectedOutlet) {
//           // localStorage.setItem('outletId', this.selectedOutlet);
//           let userPermissionForSelectedOutlet =
//             this.dataService.userPermissions.filter((ele: any) => {
//               if (ele.outlet_id == this.selectedOutlet) {
//                 return ele;
//               }
//             });
//           let userPermission = permissions.filter((ele: any) => {
//             if (ele.url === url) {
//               return ele;
//             }
//           });

//           // console.log(userPermission[0]);
//           userPermissionForSelectedOutlet.find((ele: any) => {
//             // console.log({
//             //   feature_id: ele.feature_id,
//             //   userPermission: userPermission[0].feature_id,
//             // });
//             if (ele.feature_id == userPermission[0]?.feature_id) {
//               this.tempPermission = ele;
//             }
//           });
//           // console.log(this.tempPermission);
//           if (!this.tempPermission) {
//             this.navigateToOpenUrl();
//             return false;
//           } else {
//             if (userPermission && this.tempPermission) {
//               const featurePermission = Object.keys(userPermission[0])[2];
//               switch (featurePermission) {
//                 case 'view':
//                   if (userPermission[0]) {
//                     if (userPermission[0].view == this.tempPermission.view) {
//                       returnValue = true;
//                     }
//                   }
//                   break;
//                 case 'create':
//                   if (userPermission[0]) {
//                     if (
//                       userPermission[0].create == this.tempPermission.create
//                     ) {
//                       returnValue = true;
//                     }
//                   }
//                   break;
//                 case 'update':
//                   if (userPermission[0]) {
//                     if (
//                       userPermission[0].update == this.tempPermission.update
//                     ) {
//                       returnValue = true;
//                     }
//                   }
//                   break;
//                 case 'delete':
//                   returnValue = true;
//                   break;
//                 default:
//                   returnValue = false;
//                   break;
//               }
//               this.tempPermission = '';
//             } else {
//               return false;
//             }
//           }
//         } else {
//           return false;
//         }
//       }
//       if (!returnValue) {
//         this.navigateToOpenUrl();
//       }
//       return returnValue;
//     }
//   }

//   // navigate to first url which is enabled
//   navigateToOpenUrl() {
//     // if (this.counter === 0)
//     //   this.utilityService.alertError(
//     //     'You do not have permission to access this.'
//     //   );
//     // console.log('counter', this.counter);
//     // if (this.counter > 0) {
//     //   this.counter--;
//     //   return;
//     // }
//     let perms = this.dataService.userPermissions.filter(
//       (ele: any) => ele.outlet_id == this.selectedOutlet
//     );
//     let permission = perms.find(
//       (ele: any) =>
//         ele.view === 1 ||
//         ele.create === 1 ||
//         ele.update === 1 ||
//         ele.delete === 1
//     );
//     if (permission) {
//       let p = permissions.find(
//         (ele: any) => ele.feature_id === permission.feature_id
//       );
//       if (p) {
//         this.router.navigate([p.url]);
//       }
//     }
//   }

//   getSelectedOutlet() {
//     let outletId = localStorage.getItem('outletId');
//     if (outletId) {
//       // check if this outlet Id exists in user permissions
//       let outlet = this.dataService.userPermissions.find(
//         (ele: any) => ele.outlet_id == outletId
//       );
//       if (outlet) {
//         return outletId;
//       } else {
//         if (outlet) {
//           return this.dataService.userPermissions.find(
//             (ele: any) => ele.outlet_id
//           )?.outlet_id;
//         } else {
//           this.utilityService.alertError(
//             "You don't have any outlet permissions."
//           );

//           localStorage.clear();
//         }
//       }
//     } else {
//       return this.dataService.userPermissions.find((ele: any) => ele.outlet_id)
//         .outlet_id;
//     }
//   }
//   areQueryParamsWithoutNumbers(queryParams: {
//     [key: string]: string;
//   }): boolean {
//     for (const key in queryParams) {
//       if (queryParams.hasOwnProperty(key)) {
//         const value = queryParams[key];
//         if (!isNaN(Number(value))) {
//           // If the value can be converted to a number, return false
//           return true;
//         }
//       }
//     }
//     // If none of the values could be converted to a number, return true
//     return false;
//   }
// }

import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { DataService } from 'src/app/services/data/data.service';
import { permissions } from '../../permissions';
import { UtilityService } from 'src/app/services/utility/utility.service';
@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
  constructor(
    private dataService: DataService,
    private router: Router,
    private utilityService: UtilityService
  ) {}

  tempPermission: any;
  selectedOutlet: any;

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.isAdminUser()) {
      return true;
    }

    const url = this.sanitizeUrl(state.url, route.params);
    if (!url) {
      this.navigateToOpenUrl();
      return false;
    }

    this.selectedOutlet = this.getSelectedOutlet();
    if (!this.selectedOutlet) {
      return false;
    }

    const userPermissions = this.getUserPermissionsForSelectedOutlet();
    const routePermissions = this.getRoutePermissions(url);

    if (!routePermissions) {
      this.navigateToOpenUrl();
      return false;
    }

    const hasPermission = this.checkPermissions(
      userPermissions,
      routePermissions
    );
    if (!hasPermission) {
      this.navigateToOpenUrl();
    }

    return hasPermission;
  }

  private isAdminUser(): boolean {
    return this.dataService.userDetails.is_admin === 1;
  }

  private sanitizeUrl(url: string, params: { [key: string]: string }): string {
    if (url.includes('?')) {
      url = url.split('?')[0];
    }

    const urlSegments = url.split('/');
    if (urlSegments.includes('reports')) {
      url = `/${urlSegments[1]}`;
    }

    if (this.areQueryParamsWithoutNumbers(params)) {
      Object.values(params).forEach((param) => {
        url = url.replace(`/${param}`, '');
      });
    }

    return url;
  }

  private getUserPermissionsForSelectedOutlet() {
    return this.dataService.userPermissions.filter(
      (permission: any) => permission.outlet_id == this.selectedOutlet
    );
  }

  private getRoutePermissions(url: string) {
    return permissions.find((permission: any) => permission.url === url);
  }

  private checkPermissions(
    userPermissions: any[],
    routePermissions: any
  ): boolean {
    this.tempPermission = userPermissions.find(
      (permission: any) => permission.feature_id == routePermissions?.feature_id
    );

    if (!this.tempPermission) {
      return false;
    }

    const featurePermission = this.getFeaturePermission(routePermissions);
    return this.isPermissionGranted(
      featurePermission,
      routePermissions,
      this.tempPermission
    );
  }

  private getFeaturePermission(routePermissions: any): string {
    const featurePermission = Object.keys(routePermissions).find((key) =>
      ['view', 'create', 'update', 'delete'].includes(key)
    );

    // Ensure a string is always returned
    return featurePermission ?? ''; // Return an empty string if undefined
  }

  private isPermissionGranted(
    featurePermission: string,
    routePermissions: any,
    userPermission: any
  ): boolean {
    if (!featurePermission) {
      return false;
    }

    switch (featurePermission) {
      case 'view':
        return routePermissions.view == userPermission.view;
      case 'create':
        return routePermissions.create == userPermission.create;
      case 'update':
        return routePermissions.update == userPermission.update;
      case 'delete':
        return true;
      default:
        return false;
    }
  }

  private navigateToOpenUrl(): void {
    const userPermissions = this.getUserPermissionsForSelectedOutlet();
    const firstPermission = userPermissions.find(
      (permission: any) =>
        permission.view === 1 ||
        permission.create === 1 ||
        permission.update === 1 ||
        permission.delete === 1
    );

    if (firstPermission) {
      const route = permissions.find(
        (permission: any) =>
          permission.feature_id === firstPermission.feature_id
      );

      if (route) {
        this.router.navigate([route.url]);
      }
    }
  }

  private getSelectedOutlet(): any {
    const outletId = localStorage.getItem('outletId');

    if (outletId && this.doesOutletExist(outletId)) {
      return outletId;
    }

    return this.getFirstAvailableOutlet();
  }

  private doesOutletExist(outletId: string): boolean {
    return this.dataService.userPermissions.some(
      (permission: any) => permission.outlet_id == outletId
    );
  }

  private getFirstAvailableOutlet(): any {
    const firstOutlet = this.dataService.userPermissions.find(
      (permission: any) => permission.outlet_id
    );

    if (!firstOutlet) {
      this.utilityService.alertError("You don't have any outlet permissions.");
      localStorage.clear();
      return null;
    }

    return firstOutlet.outlet_id;
  }

  private areQueryParamsWithoutNumbers(queryParams: {
    [key: string]: string;
  }): boolean {
    return Object.values(queryParams).some((value) => !isNaN(Number(value)));
  }
}
